import { isAdvisorExpired } from '../userManager/advisor';

export const requestWithHeaders = ({ method = 'GET', url, headers}) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.open(method, url);

    if (headers) {
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.setRequestHeader('Authorization', headers.auth);
      xhr.setRequestHeader('Ocp-Apim-Subscription-Key', headers.ocp);
    }

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(xhr.response);
      } else if (xhr.status === 401 || xhr.status === 403) {
        isAdvisorExpired(xhr);
      } else {
        reject(xhr);
      }
    };

    xhr.send();
  });
}

export const requestNoHeaders = ({ method = 'GET', url}, success, error) => {
  const xhr = new XMLHttpRequest();
  xhr.withCredentials = true;
  xhr.addEventListener("readystatechange", function () {
    if (this.readyState === 4) {
      if (success)
        success(xhr.response);
    }else {
      if (error)
        error(xhr.response)
    }
  });
  xhr.open(method, url);
  xhr.send();
}
